class MemberList {
	constructor(container) {
		this._container = ge(container);
		this._members = [];
		this._guardians = null;

		this.selection = new SelectionMgr();
		this.teams = new TeamList();

		this.selection.addButton(
			this.selectionTeamsBtn = UI.priIconBtn('users-team', 18, {
				'click': _ => this.teams.members(this.selection.ids, this.selectionTeamsBtn)
			})
		);

		if (nav.unit.isAdmin) {
			ge('sticky-bar').appendChild(UI.div('flex-0', [
				UI.priIconBtn('plus-square', 18, {'click': this.addNewMember.bind(this)}),
				UI.priIconBtn('users-team', 18, {'click': _ => this.teams.openDialog()})
			]));
		}

		this.moreMenu = Dialog.Popup(null);

		this._newMemberDialog;
		this._newMemberForm;

		onEv(document, 'primaryDataInvalid', () => this.getList());
		this.getList();
	}

	getList() {
		API.fetch('members')
		.then(reply => {
			if (showError(reply)) return;
			nav.unit.guardians = reply.guardians;
			this._members = [];
			this._container.innerHTML = '';
			if (reply.members && Array.isArray(reply.members)) {
				reply.members.forEach((data) => {
					let member = Member.fromArray(data, this);
					this._members.push(member);
					this._container.appendChild(member.elem);
				});
			}
			document.dispatchEvent(new Event('primaryDataLoaded'));
		});
	}

	showMoreMenu(item) {
		this._moreItem = item;
		// this.moreMenu.handle(item.moreBtn);
	}

	allocateLicence(member) {
		
	}

	get newMemberDialog() {
		if (this._newMemberDialog == null) {
			this._newMemberDialog = Dialog.Modal('newMember', _('New Members'), LARGE, _('INVITE'));
		}
		else {
			this._newMemberDialog.clear();
		}
		return this._newMemberDialog;
	}

	get newMemberForm() {
		if (this._newMemberForm == null) {
			this._newMemberPermissions = new MemberPermission();
			this._newMemberForm = UI.div('p-3', [
				UI.label('Email or Username'),
				this._newMemberSearch = UI.text(''),
				this._newMemberPermissionsDiv = UI.div('', [
					UI.label('Permissions'),
					this._newMemberPermissions.elem
				])
			]);
		}
		this._newMemberSearch.value = '';

		return this._newMemberForm;
	}

	addNewMember() {
		this.newMemberDialog.open(
			this.saveNewMember.bind(this),
			this.finish.bind(this)
		);
		this.newMemberDialog.body = this.newMemberForm;
		this._newMemberSearch.select();
	}

	saveNewMember() {
		API.insert(
			'members',
			{
				search: this._newMemberSearch.value,
				permissions: this._newMemberPermissions.value
			}
		)
		.then(reply => {
			if (showError(reply)) return;
			makeToast(_("The invitation was sent successfully."));
			refreshPrimaryData();
		})
		this.finish();
	}

	finish() {
		this.newMemberForm == null;
	}

}